import { wordBreak } from 'lib/core';
import styled from 'styled-components';

const PageHeaderWrapper = styled.div`
  ${wordBreak}
  background-color: ${({ theme }) => theme.color.additional.light.value};
  border-bottom: 1px solid ${({ theme }) => theme.color.gray[300].value};
  color: ${({ theme }) => theme.color.additional.dark.value};
  flex: 1;
`;

export { PageHeaderWrapper };
